import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Events, Platform } from 'ionic-angular';

import { UserProvider } from '../../providers/user';
import { TeamappProvider } from '../../providers/teamapp';
import { MessageProvider } from '../../providers/message';

import { MessagecenterPage } from '../messagecenter/messagecenter';
import { WorkplanPage } from '../workplan/workplan';
import { NewsReadPage } from '../news-read/news-read';
import { MagazinePage } from '../magazine/magazine';

import { TabsPage } from '../tabs/tabs';

import { InAppBrowser } from '@ionic-native/in-app-browser';

import * as moment from 'moment';
import 'moment/locale/de';

/**
 * Generated class for the DashboardPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-dashboard',
  templateUrl: 'dashboard.html',
})
export class DashboardPage {

  dashboard: any;
  platformName: string = 'unknown';

  newsTemplate: string = 'list';

  constructor(public platform: Platform, public navCtrl: NavController, public events: Events, public navParams: NavParams, public userProvider: UserProvider, public teamappProvider: TeamappProvider, public messageProvider: MessageProvider, private iab: InAppBrowser) {

    if(this.platform.is('android')) {
        this.platformName = 'android';
    } else if(this.platform.is('ios')) {
      this.platformName = 'ios';
    }

    this.teamappProvider.http_request('platform='+this.platformName+'&appversion='+this.userProvider.getUserAppVersion(), 'dashboard', false, true).then(data => {
        this.dashboard = data;
        console.log(data);
    });

  }

  getLoadDate() {
      return moment().format('DD.MM.YYYY');
  }

  formatNewsDate(date: any) {
      return moment(date).format('DD.MM.YYYY');
  }

  formatPostDate(date: any) {
      return moment(date).format('DD.MM.YYYY');
    //return moment(date).fromNow();
  }

  closePost(post: any) {
      this.dashboard = '';
      this.teamappProvider.http_request('action=set_post_state&post='+post.id+'&state=closed', 'posts', false, true).then(data => {
          this.teamappProvider.http_request('', 'dashboard', false, true).then(data => {
              this.dashboard = data;
          });
      });
  }

  onBoxClick(box: string) {
      if(box == 'projects') {
          this.navCtrl.push(WorkplanPage, {title: this.dashboard.workplan_title});
      } else if(box == 'messages') {
          this.navCtrl.push(MessagecenterPage);
      } else if(box == 'chat') {
          this.navCtrl.push(TabsPage);
      }
  }

  openNews(news: any) {
    if(news.type == 'rss') {
        this.iab.create(news.link, '_blank');
    } else if(news.type == 'own') {
        this.navCtrl.push(NewsReadPage, {news: news});
    }
  }


    openPage(type, target, id: number, title: string) {
        if(type=='cms' || type=='') {
            this.navCtrl.push(MagazinePage,{page: id, title: title});
        }

        if(type=='module') {
            this.events.publish('app:changepage',target, title, null);
        }
    }


    ionViewDidEnter() {
        this.refreshDashboard(false);
    }
  ionViewDidLoad() {
      console.log('ionViewDidLoad DashboardPage');
  }

  reactionCallbackTest(reaction: string) {
      console.log(reaction);
  }

  onPageClick(note: any) {
      this.events.publish('app:changepage', note.module, note.module_title, note.module_parameter);
  }

  refreshDashboard(event:any){
      this.dashboard = '';
      this.teamappProvider.http_request('platform='+this.platformName+'&appversion='+this.userProvider.getUserAppVersion(), 'dashboard', false, true).then(data => {
          this.dashboard = data;
          if(event) {
              event.complete();
          }

      });
  }

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/dashboard.ts